import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logger } from './logger';

/**
 * React-Hook, der jede Routenänderung über react-router-dom loggt.
 * Initial-Mount wird als "initial route" markiert; spätere Wechsel
 * erscheinen mit Pfeil-Präfix.
 */
export function useNavigationLogger(): void {
  const location = useLocation();
  const isInitial = useRef(true);

  useEffect(() => {
    const target = `${location.pathname}${location.search}`;
    const message = isInitial.current ? `initial route ${target}` : `→ ${target}`;
    logger.info('nav', message, {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    });
    isInitial.current = false;
  }, [location.pathname, location.search, location.hash]);
}
